import { SelectionAny, SelectionDateExact } from './internal';
import { SelectionWithNoteMixin } from './mixin';
export class SelectionChanged extends SelectionWithNoteMixin(SelectionAny) {
    getExactDate() {
        return this.get("DATE" /* Tag.Date */, null, SelectionDateExact);
    }
}
//# sourceMappingURL=SelectionChanged.js.map